<template>
  <validation-provider :rules="rules" :name="`${tab}.${field}`" v-slot="{ valid, errors, changed }">
    <div>
      <b-form-checkbox
        :state="onValidateField(valid, errors, changed)"
        v-model="localField"
        @change="updateField"
        :value="value"
        unchecked-value=""
      >
        {{labelText}}
      </b-form-checkbox>
      <b-form-invalid-feedback id="inputLiveFeedback">{{ errors[0] }}</b-form-invalid-feedback>
    </div>
  </validation-provider>
</template>

<script>
  import { ValidationProvider } from 'vee-validate'
  import { mapState } from 'vuex'
  import { validateField } from '@/helpers/formHelper.js'

  export default {
    data: () => ({
      localField: ''
    }),
    created () {
      this.localField = this.getField
    },
    components: {
      ValidationProvider
    },
    props: {
      tab: {
        type: String,
        required: true
      },
      helpText: String,
      field: {
        type: String,
        required: true
      },
      value: {
        type: [String, Array]
      },
      placeholder: String,
      className: String,
      rules: String,
      labelText: {
        type: String,
        required: true
      }
    },
    computed: mapState({
      getField (state) {
        const { tab, field } = this
        return state.calculator.formData[tab][field]
      }
    }),
    methods: {
      updateField (value) {
        const { tab, field } = this

        this.$store.commit('calculator/SET_FORMFIELD_VALUE', {
          tab,
          field,
          value
        })
      },
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      }
    }
  }
</script>
